export default "__VITE_ASSET__CLqh5VAL__";